import styled from 'styled-components';

export const SecureCont = styled.div`
    border-radius: 0.4rem;
    background-color: #ffffff;
    margin: ${p => p.margin ? p.margin : ''};
`;
export const SecureHeader = styled.div`
    padding: 2.3rem 3rem 2rem 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3{
        font-family: 'Rubik';
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 600;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
    .poweredBy{
        display: flex;
        align-items: center;
        margin-top: 0.8rem;
    }
    .poweredByText{
        font-family: 'Rubik';
        font-size: 1.1rem;
        color: #c2c2c2;
        margin-left: 0.6rem;
    }
`;

export const SecureContent = styled.div`
    padding: 2.5rem 3rem;
    border-top: 0.1rem #e5edf6 solid;
    .tncList{
        margin-bottom: 2rem;
    }
    .tncList li{
        margin-bottom: 1.5rem;
        label{
            font-size: 1.4rem;
            color: #000000;
            font-weight: 600;
        }
    }
    .tncText{
        margin: 0.2rem 0 0 0.8rem;
        font-size: 1.4rem;
    }
    .requiredTag{
        display: inline-flex;
        align-items: center;
        justify-content:center;
        padding: 0.2rem 0.6rem;
        border-radius: 0.2rem;
        background-color: #2276e3;
        color: #fff;
        font-size: 1.2rem;
        font-weight: 600;
        margin-right: 1rem;
    }
    .requiredText{
        color: #777777;
        font-size: 1.4rem;
    }
`;
